import Swiper, { Navigation, Autoplay } from 'swiper';

import 'swiper/css/bundle';


const swiper = new Swiper('.info-slider', {
    modules: [Navigation, Autoplay],
    loop: true,
    speed: 1000,
    slidesPerView: 1.2,
    spaceBetween: 32,

    breakpoints: {
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 72,
        },
    },

    autoplay: {
        delay: 3500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    navigation: {
        nextEl: '.swiper-next-btn',
        prevEl: '.swiper-prev-btn',
    },
});
